export default "__VITE_ASSET__CsHoUce___"